import { render, staticRenderFns } from "./TopAgent.vue?vue&type=template&id=5bb963b3&scoped=true&"
import script from "./TopAgent.vue?vue&type=script&lang=js&"
export * from "./TopAgent.vue?vue&type=script&lang=js&"
import style0 from "./TopAgent.vue?vue&type=style&index=0&id=5bb963b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb963b3",
  null
  
)

export default component.exports